import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import * as xml2js from 'xml2js';
import {forkJoin, from, Observable, of, switchMap} from 'rxjs';
import {Expiration} from "../../interfaces/Expiration";
import {PlayerList} from "../../player/player.list";
import {catchError} from "rxjs/operators";
import {CachingService} from "../../services/caching/caching.service";

@Component({
  selector: 'app-xml-player',
  template: `
    <div #component>
      <template #playercontainer></template>
      <ngx-flicking #flk [options]=options>
          <app-flicking-item flicking-panel *ngFor="let page of pages" class="flicking-panel"
                       [setParentPlayer]="this"
                       [setEditMode]="editMode"
                       [setPage]="page">
          </app-flicking-item>
      </ngx-flicking>
    </div>`,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogPlayerComponent extends PlayerList {
  constructor(protected  injector: Injector) {
    super(injector);
  }

  getConfig() { return this.data.Catalog[0].$; }
  getScene() {  return this.data.Catalog[0].Player[0]; }


  loadProviderData(): Observable<any> {
    const categories = {};
    this.data.Catalog[0].Categories[0].Category.forEach(category => {
      const categoryId = Number(category.$.id);
      categories[categoryId] = true;
    });

    return this.playerService.caching.getRecord("catalog_categories", -1).pipe(
      switchMap( catalog => {
        const items = []
        catalog.items.forEach(item=> {
          if (categories[item.category]) {
            items.push(item.item);
          }
        })

        const list = [];
        items.forEach(item => {
          list.push(this.playerService.caching.getRecord('catalog_items', item));
        })
        return forkJoin(list);
      })
    )
  }
}
